import { TimeRange } from 'common-constants/timeRange'
import { addZeroBeforeTimeUnit } from 'functions/number/addZeroBeforeTimeUnit'

import { fixCrossPlatformDateString } from './dateTime'

/**
 * Возвращает разницу текущего и переданного времени в формате: H:MM:SS
 * @param date1 - дата с которой нужно провести сравнение
 * @param date2 - дата с которой нужно провести сравнение (по умолчанию это текущее время)
 */
export const calcTimeDiff = (
  date1: string | number | Date,
  date2: string | Date = new Date()
): number => {
  const milliseconds = Math.abs(
    new Date(fixDate(date1)).getTime() - new Date(fixDate(date2)).getTime()
  )

  return milliseconds
}

export const showFullHours = (milliseconds: number): number => {
  const dateRemain = new Date(milliseconds)

  return dateRemain.getUTCHours()
}

export const showFullTime = (milliseconds: number) => {
  const dateRemain = new Date(milliseconds)

  const hours = dateRemain.getUTCHours()
  const minutes = addZeroBeforeTimeUnit(dateRemain.getUTCMinutes())
  const seconds = addZeroBeforeTimeUnit(dateRemain.getUTCSeconds())

  if (hours === 0) {
    return `${minutes}:${seconds}`
  }

  return `${hours}:${minutes}:${seconds}`
}

const fixDate = (date: string | number | Date) => {
  return typeof date === 'string' ? fixCrossPlatformDateString(date) : date
}

export const calcDaysDiff = (
  autoDeleteDate: string | number,
  dateNow: Date
) => {
  const millisecondsDiff = Math.abs(
    dateNow.getTime() - new Date(autoDeleteDate).getTime()
  )

  return Math.floor(millisecondsDiff / TimeRange.day)
}

export const isDateOverdue = (autoDeleteDate: string | number): boolean => {
  const currentDate = Date.now()

  if (typeof autoDeleteDate === 'number') {
    return autoDeleteDate <= currentDate
  } else {
    return (
      new Date(fixCrossPlatformDateString(autoDeleteDate)!).getTime() <=
      currentDate
    )
  }
}
